// extracted by mini-css-extract-plugin
export default {"tableContainer":"OrthographicDeviationsTable_tableContainer__-imdE"};